const React = require("react");
const T = require("prop-types");
const RaisedButton = require("material-ui/RaisedButton").default;
const Classes = require("./styles.scss");
const TextField = require("material-ui/TextField").default;
const HelpIcon = require("material-ui/svg-icons/action/help").default;
const IconButton = require("material-ui/IconButton").default;
const Dialog = require("material-ui/Dialog").default;
const SelectField = require("material-ui/SelectField").default;
const Checkbox = require("material-ui/Checkbox").default;
const MenuItem = require("material-ui/MenuItem").default;
const NavLink = require("react-router-dom").NavLink;
const PDFLinkMeasurements = require("static/measurement-guide.pdf");
const QuickStartGuide = require("static/quick-start-guide.pdf");
const StrangeForms = require("strange-forms");
const { RadioButton, RadioButtonGroup } = require("material-ui/RadioButton");
const {
    Step,
    Stepper,
    StepButton,
    StepContent
} = require("material-ui/Stepper");
const CroquisMeasurements = require("utils/croquis-measurements");

const internals = {};

internals.getFieldValue = (props, field) => {
    const { croquis } = props;

    if (!croquis || !croquis.measurements[field]) {
        return "";
    }

    return croquis.measurements[field].toString();
};

internals.getBooleanFieldValue = (props, field) => {
    const { croquis } = props;
    const fieldObj = CroquisMeasurements.getField(field);

    if (!croquis) {
        return "";
    }

    const curVal = !fieldObj.reducer
        ? croquis.measurements[field]
        : internals.getDeep(croquis.measurements, fieldObj.reducer);

    if (typeof curVal !== "boolean") {
        return "";
    }

    return curVal;
};

// Bic'd from strange-forms
internals.getDeep = (obj, deepProp) => {
    return deepProp.split(".").reduce((lastObj, prop) => {
        if (typeof lastObj !== "object" || lastObj === null) {
            return undefined;
        }

        return lastObj[prop];
    }, obj);
};

internals.labelStyle = {
    textTransform: "inherit"
};

internals.errorMessages = {
    number: "Please enter a number",
    text: "Please enter valid text",
    select: "Please select an option from the list"
};

internals.flattenFields = fields => {
    const flat = [];

    Object.keys(CroquisMeasurements.fields).map(key => {
        Object.keys(CroquisMeasurements.fields[key].fields).map(fieldKey => {
            flat.push(fieldKey);
        });
    });

    return flat;
};

internals.getRequiredFields = () => {
    const requiredFields = [];
    Object.keys(CroquisMeasurements.fields).forEach(fieldGroupKey => {
        Object.keys(CroquisMeasurements.fields[fieldGroupKey].fields).forEach(
            fieldKey => {
                const fieldObj =
                    CroquisMeasurements.fields[fieldGroupKey].fields[fieldKey];
                if (fieldObj.required) {
                    requiredFields.push(fieldKey);
                }
            }
        );
    });

    return requiredFields;
};

internals.requiredFieldError = (invalid, fieldKey, value) => {
    if (!invalid) {
        return null;
    }
    const requiredFields = internals.getRequiredFields();
    const fieldIsRequired = requiredFields.find(required => {
        return required === fieldKey && !value ? true : false;
    });
    if (fieldIsRequired) {
        return fieldKey + ": is a required field.";
    }
};

module.exports = class BodyModelNew extends StrangeForms(React.Component) {
    static propTypes = {
        submitText: T.string.isRequired,
        fetchData: T.func,
        updateFieldAction: T.func.isRequired,
        croquis: T.object.isRequired,
        match: T.object
    };

    state = {
        open: false,
        activeSteps: [Object.keys(CroquisMeasurements.fields)[0]],
        disabledButton: true,
        dialogInstructions: null,
        invalid: false
    };

    constructor(props) {
        super(props);

        const strangeFields = internals.flattenFields(CroquisMeasurements);

        this.strangeForm({
            fields: strangeFields,
            get: {
                title: "croquis.title",
                color: "croquis.measurements.flags.lineColor",
                omitBust: internals.getBooleanFieldValue,
                "*": internals.getFieldValue
            },
            act: {
                title: this.actTitleUpdate.bind(this),
                omitBust: this.actOmitBustUpdate.bind(this),
                "*": this.actMeasurementsUpdate.bind(this)
            },
            getFormValue: {
                omitBust: this.getCheckboxValue.bind(this),
                bustlineTweakVertical: this.getSelectValue.bind(this),
                color: this.getSelectValue.bind(this),
                hipCurve: this.getSelectValue.bind(this),
                thighCurveQuestionnaire: this.getSelectValue.bind(this),
                "*": this.getFormValue.bind(this)
            }
        });

        this.renderMeasurementFields = this._renderMeasurementFields.bind(this);
        this.checkIfConditionallyDisabled = this._checkIfConditionallyDisabled.bind(
            this
        );
    }

    componentDidMount() {
        const { croquis, fetchData } = this.props;

        window.scrollTo(0, 0);

        if (
            typeof croquis === "undefined" &&
            typeof fetchData !== "undefined"
        ) {
            fetchData(this.props.match.params.id);
        }
    }

    getSelectValue(ev, index, value) {
        return value || "";
    }

    getCheckboxValue(ev, checked) {
        return Boolean(checked);
    }

    getFormValue(e) {
        return (e && e.target.value) || "";
    }

    actMeasurementsUpdate(field, value) {
        const { croquis } = this.props;
        const id = croquis.id;
        const { type } = CroquisMeasurements.getField(field);

        this.props.updateFieldAction(id, field, value, type);
    }

    actOmitBustUpdate(field, val, ev, checked) {
        const { croquis } = this.props;
        const id = croquis.id;
        const { type } = CroquisMeasurements.getField(field);

        const value = Boolean(checked);

        this.props.updateFieldAction(id, field, value, type);

        // This branch represents the omit bust checkbox being switched on
        // If it's going from on to off, then we don't update bustlineTweakVertical state,
        // as we're re-enabling that field
        if (value) {
            // This call's bustlineTweakVertical's getFormValue handler, as configured in our strangeforms instantiation,
            // which is getSelectValue. Simply put, we're setting the value to null by passing null as the 3rd arg (the field's new value)
            this.proposeNew("bustlineTweakVertical")(
                undefined,
                undefined,
                null
            );
            // We also null the full bust measurement
            this.proposeNew("fullBust")(undefined, undefined, null);
        }
    }

    actTitleUpdate(field, value) {
        const { croquis } = this.props;

        const id = croquis.id;

        this.props.updateTitleAction(id, value);
    }

    handleOpenDialog = (fieldTitle, instructions, photo) => {
        const dialogTitle =
            typeof instructions === "object" && instructions.dialogTitle
                ? instructions.dialogTitle
                : `How to ${
                      fieldTitle === "Line Color" ? "Choose" : "Measure"
                  } ${fieldTitle}`;

        let dialogInstructions = instructions.text || instructions;
        let dialogImage = photo;

        // Handling this case fragiley because at this check is a one-off, specific to bust omitting
        // Given the frequency and sometimes idiosyncracy of new client requirements of the measurements
        // form, it seems best to under-invest in the saneness of solutions to small-scope problems.
        if (fieldTitle === CroquisMeasurements.getField("underBust").title) {
            const bustOmitted = internals.getBooleanFieldValue(
                this.props,
                "omitBust"
            );
            const underBustContent = instructions(bustOmitted);
            dialogInstructions = underBustContent.instructions;
            dialogImage = underBustContent.photo;
        }
        this.setState({
            open: true,
            dialogTitle,
            dialogInstructions: { __html: dialogInstructions },
            dialogImage
        });
    };

    handleCloseDialog = () => {
        this.setState({ open: false });
    };

    handleNumberInputScroll = event => {
        event.currentTarget.blur();
    };

    generateFieldLabel = (fieldObj, unit) => {
        return (
            (fieldObj.required ? "* " : "") +
            fieldObj.title +
            (fieldObj.type === "number" ? ` (${unit})` : "")
        );
    };

    generateFieldError = (fieldKey, fieldObj, genCustomError) => {
        let errorText = internals.errorMessages[fieldObj.type];
        if (genCustomError) {
            errorText = genCustomError(fieldKey, fieldObj);
        }

        return (
            this.fieldError(fieldKey, errorText) ||
            internals.requiredFieldError(
                this.state.invalid,
                fieldKey,
                this.fieldValue(fieldKey)
            )
        );
    };

    onSubmit = (croquis, action) => {
        // Validation here means checking the current field (not state) values for:
        // - do all field values match the state values (which are necessarily valid, as they're validated in the reducer on entry)?
        // - are all required fields filled in?
        // We don't rerun CroquisMeasurements.isValidField at all b/c any values in state are guaranteed to have passed through that
        // In short, we're confirming that state matches the user's intent (as described by field values)
        const requiredFields = internals
            .getRequiredFields()
            .filter(
                fieldKey =>
                    CroquisMeasurements.getField(fieldKey).type !== "noop"
            )
            .filter(
                fieldKey =>
                    !this.checkIfConditionallyDisabled(
                        CroquisMeasurements.getField(fieldKey)
                    )
            );

        const validationErrors = internals
            .flattenFields(CroquisMeasurements)
            .filter(
                field =>
                    this.fieldError(field) ||
                    (requiredFields.includes(field) && !this.fieldValue(field))
            );

        if (validationErrors.length) {
            const invalidFieldGroups = Object.keys(
                CroquisMeasurements.fields
            ).filter(cat => {
                return validationErrors.some(field =>
                    CroquisMeasurements.fields[cat].fields.hasOwnProperty(field)
                );
            });
            this.props.onError("Please fill out all required fields");
            return this.setState({
                invalid: true,
                activeSteps: invalidFieldGroups
            });
        }

        this.setState({ invalid: false });
        action(croquis);
    };

    renderMeasurementFieldsContent = (fieldKey, fieldObj) => {
        switch (fieldObj.type) {
            case "radiobutton":
                return (
                    <RadioButtonGroup
                        name={`measurement-${fieldKey}-input-group`}
                        valueSelected={this.fieldValue(fieldKey)}
                        className={Classes.radioGroup}
                        onChange={this.proposeNew(fieldKey)}
                        style={{ marginTop: "30px" }}
                    >
                        {Object.keys(fieldObj.buttons).map(buttonKey => (
                            <RadioButton
                                key={buttonKey}
                                value={fieldObj.buttons[buttonKey].value}
                                label={fieldObj.buttons[buttonKey].label}
                                style={{
                                    display: "inline-block",
                                    width: "150px"
                                }}
                            />
                        ))}
                    </RadioButtonGroup>
                );
                break;

            case "select":
                return (
                    <SelectField
                        // second condition sets our clear option as the default when state is empty
                        // See reducers/croquis for how we ensure state is empty on selecting "clear" option
                        value={
                            this.fieldValue(fieldKey) ||
                            (Object.keys(fieldObj.options).includes("clear") &&
                                "clear")
                        }
                        onChange={this.proposeNew(fieldKey)}
                        floatingLabelText={this.generateFieldLabel(fieldObj)}
                        floatingLabelStyle={
                            fieldObj.longLabel && { top: "20px" }
                        }
                        errorText={this.generateFieldError(
                            fieldKey,
                            fieldObj,
                            (fieldKey, fieldObj) => {
                                // This mismatch between state and form field is intentional, so should not display an error message to the user
                                if (
                                    !internals.getFieldValue(
                                        this.props.croquis,
                                        fieldKey
                                    ) &&
                                    this.fieldValue(fieldKey) === "clear"
                                ) {
                                    return false;
                                }

                                return internals.errorMessages[fieldObj.type];
                            }
                        )}
                        autoWidth
                        id={fieldObj.id}
                    >
                        {Object.keys(fieldObj.options).map(optionKey => {
                            return (
                                <MenuItem
                                    key={optionKey}
                                    value={optionKey}
                                    primaryText={fieldObj.options[optionKey]}
                                />
                            );
                        })}
                    </SelectField>
                );
                break;

            case "range":
                return (
                    <SelectField
                        value={Number(this.fieldValue(fieldKey))}
                        onChange={this.proposeNew(fieldKey)}
                        floatingLabelText={this.generateFieldLabel(fieldObj)}
                        errorText={this.generateFieldError(fieldKey, fieldObj)}
                    >
                        {/* Bic'd from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from?v=example#Sequence_generator_(range) */}
                        {Array.from(
                            {
                                length:
                                    (fieldObj.range.max -
                                        fieldObj.range.min +
                                        1) /
                                    fieldObj.range.step
                            },
                            (_, index) =>
                                fieldObj.range.min + index * fieldObj.range.step
                        )
                            .reverse()
                            .map(val => {
                                return val === 0 ? (
                                    <MenuItem
                                        key={val}
                                        value={val}
                                        primaryText={fieldObj.range.zeroText}
                                    />
                                ) : (
                                    <MenuItem
                                        key={val}
                                        value={val}
                                        primaryText={
                                            Math.sign(val) === 1
                                                ? `+${val}`
                                                : val
                                        }
                                    />
                                );
                            })}
                    </SelectField>
                );
                break;

            case "checkbox":
                return (
                    <Checkbox
                        label={this.generateFieldLabel(fieldObj)}
                        onCheck={this.proposeNew(fieldKey)}
                        checked={Boolean(this.fieldValue(fieldKey))}
                    />
                );

            case "noop":
                return (
                    <span
                        onClick={() =>
                            this.handleOpenDialog(
                                fieldObj.title,
                                fieldObj.instructions,
                                fieldObj.photo
                            )
                        }
                    >
                        <TextField
                            floatingLabelText={this.generateFieldLabel(
                                fieldObj
                            )}
                            floatingLabelStyle={{
                                color: "#555555",
                                fontSize: "14px"
                            }}
                            disabled
                            style={{
                                cursor: "pointer",
                                width: "70px",
                                marginBottom: "16px"
                            }}
                            underlineShow={false}
                        />
                    </span>
                );

            default:
                const { units } = this.props.croquis.measurements;
                return (
                    <TextField
                        floatingLabelText={this.generateFieldLabel(
                            fieldObj,
                            units
                        )}
                        value={this.fieldValue(fieldKey)}
                        onChange={this.proposeNew(fieldKey)}
                        errorText={this.generateFieldError(fieldKey, fieldObj)}
                        type={fieldObj.type}
                        onWheel={
                            fieldObj.type === "number"
                                ? this.handleNumberInputScroll
                                : undefined
                        }
                        style={{ flexGrow: 0.1 }}
                    />
                );
                break;
        }
    };

    // Cases where we disable certain fields based on the states of others
    _checkIfConditionallyDisabled(fieldObj) {
        if (!fieldObj.disableIf) {
            return false;
        }

        const { disablingField, conditionalVal } = fieldObj.disableIf;
        const actualVal = this.fieldValue(disablingField);

        return actualVal === conditionalVal;
    }

    _renderMeasurementFields = () => {
        return Object.keys(CroquisMeasurements.fields).map((key, index) => (
            <Step key={key} active={this.state.activeSteps.includes(key)}>
                <StepButton
                    onClick={() => this.setState({ activeSteps: [key] })}
                >
                    {CroquisMeasurements.fields[key].title}
                </StepButton>
                <StepContent>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: CroquisMeasurements.fields[key].intro
                        }}
                    />
                    {Object.keys(CroquisMeasurements.fields[key].fields)
                        .filter(fieldKey => {
                            const fieldObj =
                                CroquisMeasurements.fields[key].fields[
                                    fieldKey
                                ];
                            return !this.checkIfConditionallyDisabled(fieldObj);
                        })
                        .map(fieldKey => {
                            const fieldConfig =
                                CroquisMeasurements.fields[key].fields[
                                    fieldKey
                                ];
                            return (
                                <div
                                    className={Classes.inputGroup}
                                    key={fieldKey}
                                >
                                    {this.renderMeasurementFieldsContent(
                                        fieldKey,
                                        fieldConfig
                                    )}

                                    {fieldConfig.instructions && (
                                        <IconButton
                                            onClick={() =>
                                                this.handleOpenDialog(
                                                    fieldConfig.title,
                                                    fieldConfig.instructions,
                                                    fieldConfig.photo
                                                )
                                            }
                                        >
                                            <HelpIcon />
                                        </IconButton>
                                    )}
                                </div>
                            );
                        })}
                </StepContent>
            </Step>
        ));
    };

    render() {
        const { submitText, onSubmitClick, croquis } = this.props;

        const dialogActions = [
            <RaisedButton
                label="Got It"
                primary
                onClick={this.handleCloseDialog}
                labelStyle={internals.labelStyle}
            />
        ];

        if (typeof croquis === "undefined") {
            return <div>Body model not found.</div>;
        }

        const renderedMeasurementFields = this.renderMeasurementFields();

        return (
            <div>
                <div className={Classes.measurementHeader}>
                    <div>
                        <h1>Customize Your Body Model</h1>
                        <p>
                            <i style={{ fontFamily: "Nunito" }}>
                                ** The more measurements you enter, the more
                                accurate your body model will be. Required
                                measurements are marked with an asterisk (*).
                                Click &quot;?&quot; to see each instruction or
                                check the{" "}
                                <NavLink
                                    to={PDFLinkMeasurements}
                                    target="_blank"
                                >
                                    Measurement Guide
                                </NavLink>
                                . Short on time? Print this 1-page{" "}
                                <NavLink to={QuickStartGuide} target="_blank">
                                    Quick-Start Guide
                                </NavLink>{" "}
                                and write your numbers on paper first.
                            </i>
                        </p>
                    </div>
                </div>
                <hr />
                <Stepper linear={false} orientation="vertical">
                    {renderedMeasurementFields}
                </Stepper>
                <br />
                <RaisedButton
                    label={submitText}
                    primary
                    labelStyle={internals.labelStyle}
                    onClick={() => this.onSubmit(croquis, onSubmitClick)}
                />
                <Dialog
                    title={this.state.dialogTitle}
                    actions={dialogActions}
                    modal={false}
                    open={this.state.open}
                    onRequestClose={this.handleCloseDialog}
                    children={[
                        <div className={Classes.instructionsDialog}>
                            <div
                                className={Classes.dialogImage}
                                style={{
                                    backgroundImage: `url(${this.state.dialogImage})`
                                }}
                            />
                            <p
                                dangerouslySetInnerHTML={
                                    this.state.dialogInstructions
                                }
                            />
                        </div>
                    ]}
                    autoScrollBodyContent
                />
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/BodyModelForm/index.js